import React, { useCallback } from 'react';

import { useAppDispatch } from '@src/core/hooks';
import { confirmEmailFix, setResetPasswordCode } from '@src/features/customers/auth/store/auth';
import { useRecoveryFlow } from '../hooks/useRecoveryFlow';
import { RECOVERY_STEP } from '@src/features/customers/types';
import { track } from '@src/services/analytics';

import { PasswordRecoveryEmailCard } from './PasswordRecoveryEmailCard';
import { PasswordRecoveryNewPasswordCard } from './PasswordRecoveryNewPasswordCard';
import { PasswordRecoveryPinCard } from './PasswordRecoveryPinCard';

type ForgotPasswordProps = {
  initialEmail: string;
  onBack: () => void;
};

export const ForgotPassword = (props: ForgotPasswordProps) => {
  const { initialEmail, onBack } = props;
  const dispatch = useAppDispatch();
  const { step, goBack, goToPasswordStep } = useRecoveryFlow(onBack, {
    advanceOnCodeValid: false,
  });

  const handleBackToEmail = useCallback(() => {
    track('recoveryPasswordBackClick');
    dispatch(setResetPasswordCode(undefined));
    dispatch(confirmEmailFix());
  }, [dispatch]);

  switch (step) {
    case RECOVERY_STEP.PASSWORD_RESET:
      return <PasswordRecoveryEmailCard initialEmail={initialEmail} onBack={goBack} />;
    case RECOVERY_STEP.VALID_CODE:
      return <PasswordRecoveryPinCard onBack={handleBackToEmail} onContinue={goToPasswordStep} />;
    case RECOVERY_STEP.PASSWORD_RECOVER:
      return <PasswordRecoveryNewPasswordCard onBack={handleBackToEmail} />;
    default:
      return null;
  }
};

export default ForgotPassword;
